import AppConstants from '../constants/AppConstants';
import { VehicleIssueReq, VehicleIssueRes } from '../proxy/proxy';
import { AxiosVehicleIssuesClient } from '../proxy/ProxyClients';

const VehicleIssuesService = {
  getAllVehicleIssues: (startDate: string, endDate: string): Promise<Array<VehicleIssueRes>> =>
    AxiosVehicleIssuesClient.page({
      pageNumber: 1,
      pageSize: AppConstants.MAX_PAGE_SIZE,
      dateTimeInterval: {
        startTimeUtc: startDate,
        endTimeUtc: endDate
      }
    }).then((resp) =>
      (resp?.items || [])),

  createVehicleIssue: (data: VehicleIssueReq) =>
    AxiosVehicleIssuesClient.create(data),

  updateVehicleIssue: (id: number, data: VehicleIssueReq) =>
    AxiosVehicleIssuesClient.update(id, data),

  getVehicleIssue: (id: number) =>
    AxiosVehicleIssuesClient.get(id)
};

export default VehicleIssuesService;
